/* eslint-disable camelcase */
import flatpickrSpanish from 'flatpickr/dist/l10n/es'
import flatpickrChinese from 'flatpickr/dist/l10n/zh-tw'

const { es } = flatpickrSpanish
const { zh_tw: zh } = flatpickrChinese

export default {
  es,
  zh,
  zh_tw: zh,
  'zh-tw': zh
}
